import { ref } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useGetEventos() {
    const eventos = ref([]);

    const getEventos = async hashTeatro => {
        const params = {
            filters: {
                tid: hashTeatro
            }
        };

        try {
            const res = await store.dispatch(config.getVuexAlias('front.events.select'), params);
            eventos.value = res.data.data;
        } catch (error) {
            console.error('Error al obtener eventos:', error);
        }
    };

    return {
        eventos,
        getEventos,
    };
}
